import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix leaflet marker icon issue
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});

const MapComponent = () => {
    const position = [21.2127, 72.8516]; // Corrected Surat coordinates

    return (
        <div style={{ position: 'relative' }}>
            {/* Address Box */}
            <div
                style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    padding: '10px',
                    borderRadius: '8px',
                    zIndex: 1000,
                    boxShadow: '0 0 10px rgba(0,0,0,0.2)',
                    fontSize: '14px',
                    maxWidth: '250px',
                    color: 'black',
                }}
            >
                <strong >Lavanya Infotech Office</strong><br />
                75, First Floor Meera Nagar Soc.,<br />
                AK Road, Mini Bazar,<br />
                Varachha, Surat - 395006
            </div>

            {/* Map */}
            <MapContainer center={position} zoom={15} style={{ height: '500px', width: '100%' }}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
                />
                <Marker position={position}>
                    <Popup>
                        Lavanya Infotech Office<br />
                        Surat - 395006
                    </Popup>
                </Marker>
            </MapContainer>
        </div>
    );
};

export default MapComponent;
